"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var material_1 = require("@mui/material");
/** Basic MUI text field but with our specific styling */
exports.Component = (0, material_1.styled)(TextField_1.default)({
    '& .MuiOutlinedInput-root': {
        borderRadius: '8px',
        fontSize: '1rem',
    },
});
